module.exports = __webpack_public_path__ + "img/ceviche_de_combinacion.db6e8173.jpg";